export const CONSTANTS = {
	CURRENT_TOKEN: 'CURRENT_TOKEN',
	TOKEN_EXPIRATION_DATE: 'TOKEN_EXPIRATION_DATE',
	REFRESH_TOKEN: 'REFRESH_TOKEN',
	CURRENT_USER: 'CURRENT_USER',
	SESSION_EXPIRED_KEY: 'session_expired',
	VALID_EMAIL_REGEX: new RegExp(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/),
	HIDDEN_NAV_ROUTES: [
		/^\/[^/]+\/sections$/,
		/^\/[^/]+\/sections\/.+$/,
	],
	HIDDEN_FOOTER_ROUTES: [
		/^\/[^/]+\/sections$/,
		/^\/[^/]+\/sections\/.+$/,
	]
};
